import type { SingleQueryParam } from '@/hooks/useQueryParam'
import { mapQueryParamsArray, setQueryParam } from '@/hooks/useQueryParam'
import type { VNode } from 'vue'
import Vue from 'vue'

type QueryParamDirectiveBinding = {
  value?: SingleQueryParam[] | SingleQueryParam
}

const setQueryParams = (
  el: HTMLElement,
  { value: queryParamOrArray }: QueryParamDirectiveBinding,
  vnode: VNode
) => {
  if (!queryParamOrArray) return

  const queryParams = mapQueryParamsArray(queryParamOrArray)

  const router = vnode.context?.$router

  if (router === undefined) {
    console.warn(
      `v-query-params is missing context or query parameters:\n\tvalue=${queryParamOrArray}\n\trouter=${router}`
    )
    return
  }
  queryParams.forEach(({ keep, ...param }) => {
    setQueryParam(param, router)
  })
}

Vue.directive('query-params', setQueryParams)
